import { render } from "./XboxGamePassPriceUpdate.vue?vue&type=template&id=f9949c5c&scoped=true"
import script from "./XboxGamePassPriceUpdate.vue?vue&type=script&lang=js"
export * from "./XboxGamePassPriceUpdate.vue?vue&type=script&lang=js"

import "./XboxGamePassPriceUpdate.vue?vue&type=style&index=0&id=f9949c5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9949c5c"]])

export default __exports__